'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_React$Component) {
    _inherits(InfiniteScroll, _React$Component);

    function InfiniteScroll() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, InfiniteScroll);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call.apply(_ref, [this].concat(args))), _this), _this.isTopEnabled = _this.props.defaultTopEnabled, _this.isBottomEnabled = _this.props.defaultBottomEnabled, _this.debouncedScroll = (0, _throttle2.default)(function () {
            return _this.onScroll();
        }, _this.props.scrollInterval), _this.setRef = function (ref) {
            var el = this.el;
            (0, _isFunction2.default)((0, _get2.default)(el, 'removeEventListener')) && el.removeEventListener('scroll', this.debouncedScroll);
            this.el = ref;
        }.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InfiniteScroll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getScrollElement().addEventListener('scroll', this.debouncedScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.getScrollElement().removeEventListener('scroll', this.debouncedScroll);
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var distanceScrolledFromTop = this.getDistanceScrolled();
            var topThreshold = this.props.topThreshold;

            var augmentedBottomThreshold = this.getBottomThreshold();

            if (!this.isTopEnabled && distanceScrolledFromTop > topThreshold) {
                this.isTopEnabled = true;
            }
            if (this.isTopEnabled && distanceScrolledFromTop <= topThreshold && (0, _isFunction2.default)(this.props.onHitTop)) {
                this.props.onHitTop();
            } else if (distanceScrolledFromTop >= augmentedBottomThreshold && (0, _isFunction2.default)(this.props.onHitBottom)) {
                this.props.onHitBottom();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.cloneElement(this.props.children, {
                ref: this.setRef
            });
        }
    }]);

    return InfiniteScroll;
}(_react2.default.Component);

InfiniteScroll.propTypes = {
    defaultTopEnabled: _propTypes2.default.bool.isRequired,
    defaultBottomEnabled: _propTypes2.default.bool.isRequired,
    onHitBottom: _propTypes2.default.func,
    bottomThreshold: _propTypes2.default.number,
    onHitTop: _propTypes2.default.func,
    topThreshold: _propTypes2.default.number,
    children: _propTypes2.default.object.isRequired,
    scrollInterval: _propTypes2.default.number
};
InfiniteScroll.defaultProps = {
    defaultTopEnabled: false,
    defaultBottomEnabled: true,
    scrollInterval: 100,
    bottomThreshold: 50,
    topThreshold: 50
};

var InfiniteScrollContainer = function (_InfiniteScroll) {
    _inherits(InfiniteScrollContainer, _InfiniteScroll);

    function InfiniteScrollContainer() {
        _classCallCheck(this, InfiniteScrollContainer);

        return _possibleConstructorReturn(this, (InfiniteScrollContainer.__proto__ || Object.getPrototypeOf(InfiniteScrollContainer)).apply(this, arguments));
    }

    _createClass(InfiniteScrollContainer, [{
        key: 'getScrollElement',
        value: function getScrollElement() {
            return this.el;
        }
    }, {
        key: 'getDistanceScrolled',
        value: function getDistanceScrolled() {
            var el = this.el;
            return el.scrollTop;
        }
    }, {
        key: 'getBottomThreshold',
        value: function getBottomThreshold() {
            var el = this.el;
            var bottomThreshold = this.props.bottomThreshold;

            return el.scrollHeight - (el.offsetHeight + bottomThreshold);
        }
    }]);

    return InfiniteScrollContainer;
}(InfiniteScroll);

var InfiniteScrollWindow = function (_InfiniteScroll2) {
    _inherits(InfiniteScrollWindow, _InfiniteScroll2);

    function InfiniteScrollWindow() {
        _classCallCheck(this, InfiniteScrollWindow);

        return _possibleConstructorReturn(this, (InfiniteScrollWindow.__proto__ || Object.getPrototypeOf(InfiniteScrollWindow)).apply(this, arguments));
    }

    _createClass(InfiniteScrollWindow, [{
        key: 'getScrollElement',
        value: function getScrollElement() {
            return window;
        }
    }, {
        key: 'getDistanceScrolled',
        value: function getDistanceScrolled() {
            return window.pageYOffset;
        }
    }, {
        key: 'getBottomThreshold',
        value: function getBottomThreshold() {
            var bottomThreshold = this.props.bottomThreshold;

            return this.el.offsetHeight - (window.innerHeight + bottomThreshold);
        }
    }]);

    return InfiniteScrollWindow;
}(InfiniteScroll);

exports.default = {
    Container: InfiniteScrollContainer,
    Window: InfiniteScrollWindow
};
//# sourceMappingURL=index.js.map